module.exports = __webpack_public_path__ + "static/media/seo-ux.3f8d05fd.png";